// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    appStoreUrl: '#',
    playStoreUrl: '#',
    googleClientId: '526845199010-gcqtpth23g1vsgnsla81epjg2a1b2g09.apps.googleusercontent.com',
    stripePublishableKey: 'pk_live_51IqdxVK9ZUsZXxw4svH5ajKvNNnPR6cLjywzDzw1a3mF0A5MllrVbEMRiLcJ4PEMas2ZGU3x6uifNpxKN9hm9mne00cvo7fe5e',
    apiUrl: 'https://fotbollpariktigt-admin.onebolt.ai/api',
    appUrl: 'https://fotbollpariktigt.onebolt.ai',
    googleMapApiKey: 'AIzaSyCKm_wNklUrHWRv9nINRo0uzU8V2nF4t-Y',
    // Pusher configuration
    pusher: {
        key: 'c32cdc7a5def3b2741f0',
        cluster: 'eu',
        useTLS: false,
    },
    sentryDsn: "https://9245d21bc989b038fd07de0891a4728d@o4510777967116288.ingest.de.sentry.io/4510777971769424",
    firebase: {
        apiKey: "AIzaSyCKxG7zaW14pzBKSGfzsicjOa9FAuA_P7k",
        authDomain: "fotboll-fcc19.firebaseapp.com",
        projectId: "fotboll-fcc19",
        storageBucket: "fotboll-fcc19.firebasestorage.app",
        messagingSenderId: "186396728880",
        appId: "1:186396728880:web:b050e0f1a3b8fee05297f5",
        measurementId: "G-Z8DRNNT01K",
    },
    msalConfig: {
        auth: {
            clientId: '7778c491-4e6d-41fa-bfa0-95326f8f552b',
            authority: 'https://login.microsoftonline.com/common',
            redirectUri: 'https://fotbollpariktigt.onebolt.ai'
        }
    },
    posthog: {
        key: 'phc_gqSM1EPItwinuYRl4vp6up7tcq1hkzbBsAeVddK0hNc',
        host: 'https://eu.i.posthog.com'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.